import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { LoadingScreen } from '../components/common/LoadingScreen';
import { ErrorScreen } from '../components/common/ErrorScreen';

export const GalleryPage = () => {
  // State to handle the selected image for the bigger view
  const [selectedImage, setSelectedImage] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const galleryCollectionRef = collection(db, 'gallery');
  // Read News
  const fetchImages = async () => {
    try {
      const data = await getDocs(galleryCollectionRef);
      setGalleryImages(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    } catch (err) {
      setError("Failed to fetch document: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

   // Function to handle image click
   const handleImageClick = (url) => {
    setSelectedImage(url);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImage(null);
  };

  if (loading) {
    return <LoadingScreen />;
  }

  if (error) {
    return <ErrorScreen errorMessage={error} onRetry={fetchImages} />;
  }

  return (
    <div className='min-h-screen bg-gray-100'>
      <div className='container w-full max-w-7xl mx-auto p-1'>
        <h1 className='text-4xl text-center font-bold mb-8 text-secondary'>
          Gallery
        </h1>

        {/* Image Grid with Titles and Descriptions */}
        <div className='grid grid-cols-3 sm:grid-cols-2 md:grid-cols-2 gap-4'>
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className='group relative cursor-pointer'
              onClick={() => handleImageClick(image.url)}
            >
              {/* Image */}
              <img
                src={image.url}
                alt={image.title}
                className='w-full h-64 object-cover rounded-lg shadow1 group-hover:opacity-80'
              />
              {/* Title */}
              {/* <h3 className='text-lg font-semibold mt-2'>{image.title}</h3> */}
              {/* Description */}
              <p className='text-sm text-gray-600'>{image.description}</p>
              <div className='absolute inset-0 bg-black bg-opacity-40 hidden group-hover:flex justify-center items-center text-white text-lg font-bold'>
                View
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal for Larger Image */}
      {selectedImage && (
        <div
          className='fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50'
          onClick={closeModal}
        >
          <div className='relative'>
            <button
              className='absolute top-2 right-2 text-white text-2xl bg-secondary rounded-full p-1'
              onClick={closeModal}
            >
              &times;
            </button>
            <img
              src={selectedImage}
              alt='Selected'
              className='max-w-4xl w-full h-auto rounded-lg shadow2'
            />
          </div>
        </div>
      )}
    </div>
  );
};
